import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DocmanFolderModel } from '../services/docman.model.folder';
import { UiService } from '../../../core/services/core.ui.service';
import * as _ from 'lodash';

@Component({
  selector: 'folder-edit-modal',
  template: require('./folder.edit.modal.html')
})
export class FolderEditModalComponent implements OnInit {
  @Input() folder: any;
  @Input() rootFolder: any;
  @Input() folders: any[];
  @Input() project: any;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  editFolder: any;
  originalFolderSettings: any;
  PublicPrivate = { Public: true, Private: false };
  canBePublic: boolean = false;
  acceptSave: boolean = false;
  needsUserAcceptance: boolean = false;
  showUserAcceptanceError: boolean = false;
  formErrors: any;

  constructor(
    private docmanFolderModel: DocmanFolderModel,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
    this.editFolder = _.cloneDeep(this.folder);
    this.editFolder.isPublic = ['Y', true, 1].includes(this.editFolder.isPublic);
    this.originalFolderSettings = _.cloneDeep(this.editFolder);
    this.setFolderVisibility();
  }

  private setFolderVisibility(): void {
    this.canBePublic = false;
    if (this.editFolder.isRoot) {
      this.canBePublic = true;
    } else {
      const parentFolder = this.editFolder.parentFolderId === 0 ? this.rootFolder : _.find(this.folders, { id: this.editFolder.parentFolderId });
      this.canBePublic = !!parentFolder && parentFolder.isPublic;
    }

    if (!this.canBePublic) {
      this.editFolder.isPublic = false;
    }
  }

  setIsPublic(value: boolean): void {
    this.needsUserAcceptance = false;
    if (this.originalFolderSettings.isPublic && !value) {
      this.needsUserAcceptance = true;
    }
    this.editFolder.isPublic = value;
  }

  saveFolder(): void | Promise<void> {
    if (this.needsUserAcceptance && !this.acceptSave) {
      this.showUserAcceptanceError = true;
      this.uiService.message.showWarning(
        "You have changed visibility to private; saving the folder settings requires you to check the 'accept' checkbox."
      );
      return;
    }

    let success = false;
    const folderCopy = _.clone(this.editFolder);

    // Validate folder first
    this.formErrors = this.docmanFolderModel.validateFolder(this.editFolder);
    if (!_.isEmpty(this.formErrors)) {
      this.uiService.message.showError('Folder validation failed. The folder name cannot contain slashes');
      return;
    }

    folderCopy.isPublic = ['Y', true, 1].includes(this.editFolder.isPublic);
    folderCopy.project = this.editFolder.project.id;

    return this.docmanFolderModel.saveFolder(folderCopy, false)
      .then(
        (response) => {
          success = true;
          this.uiService.message.showSuccess(`Folder settings for ${_.get(this.editFolder, 'folderName', '(unknown)')} have been updated successfully`);
          _.assign(this.folder, this.editFolder);
          this.onEdit.emit(this.folder);
        },
        (err) => {
          let msg = '';
          if (err.data?.folderName?.length > 0) {
            msg = err.data.folderName[0].type === 'required' ? 'Folder name is required' : 'Folder name must have at least 5 characters';
          }
          this.uiService.message.showError(`Error saving folder ${_.get(this.editFolder, 'folderName', '(unknown)')}: ${msg}`);
		  this.onClose.emit();
        }
      )
      .then(() => {
        this.acceptSave = false;
        this.needsUserAcceptance = false;
        this.showUserAcceptanceError = false;
      });
  }
}
